$(document).ready(function() {
    function coockieFun(id, value) {
        var cookie = JSON.parse($.cookie("cookieStore"));
        cookie[id]["kolicina"] = value;
        $.cookie("cookieStore", JSON.stringify(cookie), { path: "/" });
    }

    if ($.cookie("cookieStore")) {
        var dataExist = JSON.parse($.cookie("cookieStore"));
        if (dataExist[$("#id").val()]) {
            $("#qty").val(dataExist[$("#id").val()].kolicina);
        }
    }

    $("#insert").click(function() {
        if ($.cookie("cookieStore")) {
            var cookie = JSON.parse($.cookie("cookieStore"));
            if (cookie[$("#id").val()]) {
                var productCookie = cookie[$("#id").val()];
                var val = $("#qty").val();
                if (val != productCookie.kolicina) {
                    coockieFun($("#id").val(), val);
                }
            } else {
                cookie[$("#id").val()] = createObject();
                $.cookie("cookieStore", JSON.stringify(cookie), { path: "/" });
            }
        } else {
            var products = [];
            products[$("#id").val()] = createObject();
            $.cookie("cookieStore", JSON.stringify(products), { path: "/" });
        }
    });

    function createObject() {
        var product = new Object();
        product.name = $("#title").text();
        product.slika = $("#img").attr("src");
        product.kolicina = $("#qty").val();
        product.cena = $("#price").text();
        product.uuid = document.getElementById("uuid").value;
        return product;
    }
});
